import { createContext } from 'react';
import { useNavigate } from 'react-router';
import { CurrentIdentity, IRefreshTokenApiResponse } from './CurrentIdentity';
import { getExtensionPage } from './extension-hooks';
import { UserProfile } from './types';

export interface IIdentityContext {
	/** The profile of the user, if we know who they are. This does NOT mean they are authorized. */
	user?: UserProfile;

	/** Whether we know who the user is - a valid login session. This does NOT mean they are authorized. */
	getAccessToken: () => string | undefined;
	csrfToken?: string;

	/** Indicate whether the user is authorized to access this system */
	authorized: boolean;
	ensureAuthenticated: () => Promise<boolean>;

	/** Record user activity to prevent token refresh while user is inactive */
	recordActivity: () => void;
	/** Check if user has been active within the last 4 hours */
	userIsActive: () => boolean;
}
export const IdentityContext = createContext<IIdentityContext | undefined>(undefined);

export async function handleRefreshTokenResponse(
	result: IRefreshTokenApiResponse | undefined,
	history: ReturnType<typeof useNavigate>,
	force?: boolean
) {
	if (result?.redirect_url) {
		if (!force && isLocalAuthPage(window.location.pathname)) return false;

		// we need to request this redirect as it will initialise the identity server login
		const p = getExtensionPage(window.location.pathname.split('/')[1]);
		if (!p.anonymous || force) {
			try {
				const res = await fetch(result.redirect_url, { redirect: 'error', headers: { 'x-redirect-as-content': '1' } });
				if (!res.ok) throw new Error(`soft-redirect to ${result.redirect_url} failed`);

				const path = await res.text();
				console.log('redirecting to login page', path);
				history(path);
			} catch (e) {
				console.log('error in handlerefresh', e);
				// if the redirect happens, we will just redirect directly
				window.location.href = result.redirect_url;
			}
		}
		// window.location.href = result.redirect_url;
		return false;
	}
	if (result?.accessToken) {
		Object.assign(CurrentIdentity, result);
		return true;
	}
}

function isLocalAuthPage(pathname: string) {
	return /^\/account\/(login|guest|twofactor|reset|setpassword|forgot|setuptwofactor)(\/|$)/i.test(pathname);
}
